import React from 'react';
import Select from 'react-select';
import { FormGroup } from 'react-bootstrap';
import { customStyles } from '../../../../Components/helper';

export function DropDown({ options, value, error, placeHolder, label, name, onChange, path, disable, requiredField }) {
  return (
    <FormGroup className="flex-fill">
      <div className="custom-react-select-po">
        <label className="field-lbl mb-0 h-24 asterisk-req">
          {label}
          {requiredField && <span>*</span>}
        </label>
        <Select
          name={name}
          options={options}
          getOptionLabel={(option) => `${option?.name}`}
          getOptionValue={(option) => `${option?.name}`}
          value={value || null}
          isDisabled={disable}
          inputProps={{
            autoComplete: 'off',
            autoCorrect: 'off',
            spellCheck: 'off',
          }}
          styles={customStyles}
          onChange={(event) => onChange(event, path)}
          placeholder={placeHolder}
        />
      </div>
      {error?.status && <span className="error-message">{error.errorMsg}</span>}
    </FormGroup>
  );
}
export default DropDown;
